import React__default from 'react';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Square } from '../Square/index.js';
import styles from 'ui-components/ProductViewMedia.scss';

var _excluded = ["image", "hintImage", "children", "alt"];
var ProductImage = function ProductImage(_ref) {
  var image = _ref.image,
    hintImage = _ref.hintImage,
    children = _ref.children,
    alt = _ref.alt,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (!image.smallImage && !image.largeImage) {
    return /*#__PURE__*/React__default.createElement("div", props, /*#__PURE__*/React__default.createElement(Square, {
      className: styles.imagePlaceholder
    }));
  }
  return /*#__PURE__*/React__default.createElement("div", props, /*#__PURE__*/React__default.createElement(Square, null), /*#__PURE__*/React__default.createElement("picture", {
    style: {
      zIndex: 1,
      position: "absolute",
      top: "0",
      right: "0",
      bottom: "0",
      left: "0",
      backgroundImage: hintImage ? "url(" + hintImage + ")" : "",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat"
    }
  }, image.smallImage && /*#__PURE__*/React__default.createElement("source", {
    srcSet: image.smallImage.x1 + ", " + image.smallImage.x2 + " 2x",
    media: "(max-width: " + (parseInt(styles.breakpoint, 10) - 1) + "px)"
  }), image.largeImage && /*#__PURE__*/React__default.createElement("source", {
    srcSet: image.largeImage.x1 + ", " + image.largeImage.x2 + " 2x",
    media: "(min-width: " + parseInt(styles.breakpoint, 10) + "px)"
  }), image.smallImage && /*#__PURE__*/React__default.createElement("img", {
    src: image.smallImage.x2,
    alt: alt,
    style: {
      width: "100%",
      zIndex: 2
    }
  })));
};

export { ProductImage };
//# sourceMappingURL=image.js.map
